import { queryOptions } from '@tanstack/react-query';
import type { HevitonApiV2 } from '@heviton/heviton-api-v2';
import { fromRawSubscriptionListItem } from '@/shared/data-mappers';
import type { SubscriptionListItem } from '@/shared/data-types';

/**
 * 단건 발전소 query 정의 SSOT. BE = v2 `GET /plants/{plantId}?include=subscription,order` (`plant.detail`).
 * 구독유형 선택(plan) 페이지가 진입 발전소 1건을 **목록 페이지네이션과 무관하게** 직접 조회 — 딥링크·새로고침 안전.
 * 반환 = `SubscriptionListItem`(발전소 기본 + 구독·최신주문 합성) — plan.guard 의 구독중 차단·결제 게이팅에 재사용.
 */
export const plantQueryKey = (plantId: string) => ['plant', plantId] as const;

export const plantQueryOptions = (api: HevitonApiV2, plantId: string) =>
  queryOptions<SubscriptionListItem>({
    queryKey: plantQueryKey(plantId),
    enabled: !!plantId,
    queryFn: async ({ signal }) => {
      const raw = await api.plant.detail(
        Number(plantId),
        { include: 'subscription,order' },
        { signal },
      );
      return fromRawSubscriptionListItem(raw.plant);
    },
  });
